import React from "react";

const ReservationExpired = () => {
  return (
    <div className="reservation-expired">
      <div className="reservation-expired__icon-wrapper">
        <div className="reservation-expired__icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
          </svg>
        </div>
      </div>
      <h2 className="reservation-expired__title">Réservation expirée</h2>
      <p className="reservation-expired__message">
        Le délai de votre réservation est écoulé. Le créneau a été libéré.
      </p>
      <p className="reservation-expired__sub-message">
        Veuillez contacter votre magasin pour effectuer une nouvelle
        réservation.
      </p>
    </div>
  );
};

export default ReservationExpired;
